<template>
  <div class="layout layout--default">
    <FlashMessages />
    <NoticeMessage />
    <slot></slot>
  </div>
</template>

<script>
import FlashMessages from '@/components/_shared/FlashMessage/FlashMessages.vue'
import NoticeMessage from '@/components/_shared/NoticeMessage/NoticeMessage.vue'

export default {
  name: 'DefaultLayout',

  components: {
    FlashMessages,
    NoticeMessage,
  },
}
</script>